import { css } from '@clubspark-react/ui/components/stitches.config';

export const wtnStyles = css({
  fontFamily: 'Poppins',
  fontWeight: 600,
  background: '-webkit-linear-gradient(90deg, #16234c, #e03e52 80%)',
  backgroundClip: 'border-box',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
});

export const wtnDecimalStyles = css({
  fontSize: '75%',
});

export const wtnMarkStyles = css({
  verticalAlign: 'top',
});
